module.exports = __webpack_public_path__ + "static/media/notification.5c31f0cd.mp3";